import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ChildrenProps from "../../interfaces/common.interface";
import "./MainContent.scss";

const MainContent: React.FC<ChildrenProps> = ({ children }) => {
  return (
    <Grid
      container
      direction="column"
      className="main-content-container"
      wrap="nowrap"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      {/* Main content area  */}
      <Grid sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Box
          component="main"
          className="main-content"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
      </Grid>

      {/* Footer */}
      <Grid>
        <Box
          className="footer"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "20px",
          }}
        >
          <Typography variant="body2" color="textSecondary" textAlign="center">
            Copyright © 2025. Auto Data Labels.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MainContent;
